import React, { useEffect, useState, } from 'react';
import '../admin.list.scss';
import { useTranslation, } from 'react-i18next';
import { useNavigate, } from 'react-router-dom';
import { ColumnsType, SorterResult, } from 'antd/lib/table/interface';
import { IPreviewTag, PermissionEnum, CrudEnum, TTagSortableListCol, } from 'atlas-shared';
import { Table, } from 'antd';
import { AdminListPageHeader, ListPageEmpty, } from '@Components';
import { IWithListProps, IWithListSorterProps, withList, } from '@Hocs/with.list';
import { useAbilities, useAuth, useTags, useOrganizations, } from '@Hooks';
import { TagListColumns, } from '@Utils';
import { IAuth, } from '@Store';

const TagList = ({ filters, filtersCount, hasFilters, sorter, pagination, setQueryParams, resetQueryParams, }: IWithListProps<IPreviewTag, TTagSortableListCol>) => {
  const { t, } = useTranslation();
  const navigate = useNavigate();
  const auth: IAuth = useAuth();
  const tags = useTags();
  const abilities = useAbilities();
  const [loading, setLoading, ] = useState<boolean>(true);
  const [rows, setRows, ] = useState<Array<any>>([]);
  const organizations = useOrganizations();
  
  const [showDeleted, setShowDeleted, ] = useState(false);
  const [deletedCount, setDeletedCount, ] = useState<number>(0);
  
  useEffect(() => {
    if (!tags.loaded)
      return;
      
    setLoading(false);
    setRows((!showDeleted ? tags.tags.filter(p => !p.deleted_at) : tags.tags || []).map(row => ({ ...row, key: row.id, })));
    setDeletedCount(tags.tags.filter(tag => !!tag.deleted_at).length);
  }, [tags, showDeleted, ]);

  const columns: ColumnsType<IPreviewTag> = React.useMemo(() => {
    return TagListColumns(t, navigate, showDeleted, organizations, abilities, auth, [], filters, sorter);
  }, [t, navigate, showDeleted, organizations, abilities, auth, filters, sorter, ]);

  return <div className='admin-list-view'>
    <AdminListPageHeader 
      t={t}
      title={t('TAGS')}
      filtersCount={filtersCount}
      reset={() => resetQueryParams()}
      deleted={[showDeleted, setShowDeleted, ]} deletedCount={deletedCount}
      addBtn={abilities.canImplicit(null, CrudEnum.Insert, PermissionEnum.Tag) ? { callback: () => navigate('/admin/tag/add'), } : undefined} 
    />
    <div className='table-wrp'>
      <Table
        key={loading ? 1 : 0}
        columns={columns}
        dataSource={rows}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
        }}
        onChange={(pagination, filters, _sorter) => {
          const sorter: Array<SorterResult<any>> = Array.isArray(_sorter) ? _sorter : _sorter?.columnKey ? [_sorter, ] : [];

          setQueryParams({
            pagination: { current: pagination.current as number, pageSize: pagination.pageSize as number, },
            filters: Object.fromEntries(Object.entries(filters).filter(([key, value, ]) => value !== null)),
            sorter: sorter
              .filter(s => !!s.order)
              .map(s => ({ column: s.columnKey as TTagSortableListCol, order: s.order as IWithListSorterProps<IPreviewTag, TTagSortableListCol>['order'], })),
          });
        }}
        locale={{
          emptyText: <ListPageEmpty t={t} hasFilters={hasFilters} hasRows={!!rows.length} reset={() => resetQueryParams()} />,
        }}
      />
    </div>
  </div>;
};

export const TagListView = React.memo(withList<IPreviewTag, TTagSortableListCol>(TagList, {
  filters: {},
  sorter: [{ column: 'created_at', order: 'descend', }, ],
  pagination: { current: 1, pageSize: 10, },
}));
